import { useState, useEffect } from 'react';

export interface SelectedService {
  id: string;
  name: string;
}

export const useSelectedServices = () => {
  const [selectedServices, setSelectedServices] = useState<SelectedService[]>([]);

  // Parse URL parameters on mount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const serviceParam = urlParams.get('service');
    const servicesParam = urlParams.get('services');
    
    if (serviceParam) {
      addService(serviceParam, serviceParam);
    } else if (servicesParam) {
      const services = servicesParam.split(',');
      services.forEach(service => addService(service, service));
    }
    
    // Check hash parameters as well
    if (window.location.hash.includes('services=')) {
      const hashServices = window.location.hash.split('services=')[1]?.split(',');
      if (hashServices) {
        hashServices.forEach(service => addService(service, service));
      }
    }
  }, []);

  const addService = (id: string, name: string) => {
    setSelectedServices(prev => {
      const exists = prev.find(service => service.id === id);
      if (exists) return prev;
      
      const newService = { id, name };
      
      // Analytics event
      if (typeof window !== 'undefined' && (window as any).gtag) {
        (window as any).gtag('event', 'service_select', {
          event_category: 'engagement',
          event_label: name
        });
      }
      
      return [...prev, newService];
    });
  };

  const removeService = (id: string) => {
    setSelectedServices(prev => prev.filter(service => service.id !== id));
  };

  const clearServices = () => {
    setSelectedServices([]);
  };

  const getMessageText = () => {
    if (selectedServices.length === 0) return '';
    
    const serviceTags = selectedServices
      .map(service => `[Service: ${service.name}]`)
      .join(' ');
    
    return `${serviceTags}\n\n`;
  };

  const getServicesCSV = () => {
    return selectedServices.map(service => service.id).join(',');
  };

  return {
    selectedServices,
    addService,
    removeService,
    clearServices,
    getMessageText,
    getServicesCSV
  };
};